export default {
  name: 'Content section - 4',
  tab: 'content',
  type: 'content-default-section',
  content: {
    title: 'Content section',
    introtext:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
    image: '',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--secondary-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'lighter',
    'title-tag': 'h2',
    'introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'center',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
